import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useSnackbar } from 'notistack';

export const useAsyncDispatch = () => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const dispatchAction = useCallback(
    (action, { onSuccess, onError, errorFallback } = {}) => {
      return dispatch(action)
        .unwrap()
        .then((data) => {
          onSuccess?.(data);
          return data;
        })
        .catch((error) => {
          const message = typeof error === 'string' ? error : errorFallback || error?.message || 'Something went wrong';
          if (onError) {
            onError(message);
          } else {
            enqueueSnackbar(message, { variant: 'error' });
          }
          return null;
        });
    },
    [dispatch, enqueueSnackbar]
  );

  return dispatchAction;
};
